export default {
  extratores: [],
  extratores_list: [],
  loading: false,
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
